import { render, staticRenderFns } from "./SalesChannelChart.vue?vue&type=template&id=f78b9aaa&scoped=true"
import script from "./SalesChannelChart.vue?vue&type=script&lang=js"
export * from "./SalesChannelChart.vue?vue&type=script&lang=js"
import style0 from "./SalesChannelChart.vue?vue&type=style&index=0&id=f78b9aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78b9aaa",
  null
  
)

export default component.exports